import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card-global"
}
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "antd-tabs mb-6" }
const _hoisted_4 = { class: "antd-tabs-nav" }

import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import DocumentReportView from "@/views/reports/DocumentReportView.vue";
import SystemReportView from "@/views/reports/SystemReportView.vue";
import { AuthGetters } from "@/store/modules/auth";
import { t } from "@/i18n";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const activeTab = ref<"documents" | "system">("documents");
const router = useRouter();
const store = useStore();
const reportAccessPermissions = ["REPORT_CREATE", "REPORT_EDIT"];

const currentUser = computed(() => store.getters[AuthGetters.GET_USER_IDENTITY]);
const permissions = computed<string[]>(() =>
  Array.isArray(currentUser.value?.permissions)
    ? currentUser.value.permissions
    : []
);
const hasReportAccess = computed(() =>
  reportAccessPermissions.some((permission) =>
    permissions.value.includes(permission)
  )
);

onMounted(() => {
  if (!hasReportAccess.value) {
    router.push({ name: "Dashboard" });
  }
});

return (_ctx: any,_cache: any) => {
  return (_unref(hasReportAccess))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)("reports.title")), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("nav", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["antd-tab", { 'antd-tab--active': activeTab.value === 'documents' }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 'documents'))
            }, _toDisplayString(_unref(t)("reports.documentReportTab")), 3),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["antd-tab", { 'antd-tab--active': activeTab.value === 'system' }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'system'))
            }, _toDisplayString(_unref(t)("reports.systemReportTab")), 3)
          ])
        ]),
        (activeTab.value === 'documents')
          ? (_openBlock(), _createBlock(DocumentReportView, { key: 0 }))
          : (_openBlock(), _createBlock(SystemReportView, { key: 1 }))
      ]))
    : _createCommentVNode("", true)
}
}

})